import { Box, Typography } from "@mui/material";
import { fromUnixToMonthDayStr, getHourFromUnix } from "../../utils/unix-timestamp";

/* eslint-disable max-len */
import AvatarCustom from "../AvatarCustom/AvatarCustom";
import DollarNewIcon from "../Icons/DollarNewIcon";
import { IInvoiceItemResponse } from "../../services/invoice-view/invoice-view.interface";
import { IPetItemResponse } from "../../services/pet-list/pet-list.interface";
import PaymentHistoryCalendar from "../Icons/PaymentHistoryCalendar";
import PaymentHistoryLocation from "../Icons/PaymentHistoryLocation";
import { PromoTagIcon } from "../Icons";
import React from "react";
import { isWellnessMember } from "../../utils/wellness";

interface IPaymentHistory{
  paymentDetail: IInvoiceItemResponse;
  handleInvoiceDownload: (invoiceId: string) => void;
  petList: IPetItemResponse[];

}

const PaymentHistoryCard = ({ paymentDetail, handleInvoiceDownload, petList } : IPaymentHistory) => {
  return (
    <div className="flex flex-col bg-white p-3 w-full rounded-lg gap-2 border border-taupe-2">
      <div className="flex gap-3">
        <AvatarCustom
          image={paymentDetail.image}
          name={paymentDetail.name}
          width={56}
          height={56}
          isWellnessMember={isWellnessMember(petList, paymentDetail.petId)!}
          wellnessIconHeight={18}
          wellnessIconWidth={18}
        />
        <div className="flex flex-col gap-2">
          <div className="font-semibold">{paymentDetail.name}</div>
          <div className="text-sm flex gap-1">
            <PaymentHistoryCalendar />
            <div>
              {fromUnixToMonthDayStr(paymentDetail.date)} &#xb7;{" "}
              <span className="uppercase">{getHourFromUnix(paymentDetail.time, paymentDetail.timeZone)}</span>
            </div>
          </div>
          <div className="text-sm flex gap-1">
            <DollarNewIcon />
            <div>
              Total : ${paymentDetail.total.toFixed(2)}
            </div>
          </div>
          {paymentDetail.promoCode && paymentDetail.promoCode?.length > 0 && (
            <Box className="flex text-sm w-full gap-1 items-center">
              <PromoTagIcon color="#262626" height={20} width={20}/>
              <Typography variant="body1">Promo Applied:</Typography>
              <Box className="w-fit flex gap-1">
                {
                  paymentDetail.promoCode?.map((promo, i)=>(
                    <p key={promo} className="font-semibold text-black leading-6">{promo}
                      {paymentDetail?.promoCode && i===paymentDetail?.promoCode?.length-1 ? "." : ","}
                    </p>))
                }
              </Box>
            </Box>
          )}
          <div className="text-sm text-gray-1 flex gap-1">
            <PaymentHistoryLocation />
            <div>
              {paymentDetail.locationName}
            </div>
          </div>
        </div>
      </div>
      <div
        className="self-center border border-gray-4 py-2.5 px-5 rounded-2xl w-full
                  text-center text-sm font-semibold cursor-pointer hover:bg-gray-3"
        onClick={()=> handleInvoiceDownload(paymentDetail?.id?.toString())}>
        Download Invoice
      </div>
    </div>
  );
};

export default PaymentHistoryCard;
